module.exports = __webpack_public_path__ + "static/img/2.1f5db68.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/408/2.png
// module id = 484
// module chunks = 1